import cta_en from './cta_en.json'
import cta_fr from './cta_fr.json'
import base_en from './en.json'
import base_fr from './fr.json'
import forms_en from './forms_en.json'
import forms_fr from './forms_fr.json'
import common_en from './common_en.json'
import common_fr from './common_fr.json'
import submitClaim_en from './submitClaim_en.json'
import submitClaim_fr from './submitClaim_fr.json'
import contactInfo_en from './contact-info_en.json'
import contactInfo_fr from './contact-info_fr.json'
import rxhelpGuide_en from './rxhelp-guide_en.json'
import rxhelpGuide_fr from './rxhelp-guide_fr.json'

const lcr_resources = {
  en: {
    ...cta_en,
    ...base_en,
    ...forms_en,
    ...common_en,
    ...contactInfo_en,
    ...submitClaim_en,
    ...rxhelpGuide_en,
  },
  fr: {
    ...cta_fr,
    ...base_fr,
    ...forms_fr,
    ...common_fr,
    ...contactInfo_fr,
    ...submitClaim_fr,
    ...rxhelpGuide_fr,
  },
}

export default lcr_resources
